<!--
 * @Author: 王佳宾
 * @Date: 2022-03-21 11:45:04
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-24 14:20:33
 * @Description: 矿业市场

 * @FilePath: \web\src\components\Portal\Market\kyReport.vue
-->
<template>
  <section class="mining-report">
    <section class="top-search">
      <video class="video" src="./../../../static/video/bj.mp4" autoplay loop muted></video>
      <section class="small-title">
        <img src="./../../../static/images/portal/index/small-title.png" alt="">
      </section>
      <section class="search-content">
        <a-input-group compact class="search-group">
          <a-select v-model:value="requestParams.type" style="width: 1.5rem;height: .5rem;">
            <a-select-option v-for="(item, index) in reportTypeList" :key="index" :value="item.name">{{ item.name
            }}</a-select-option>
          </a-select>
          <a-input-search :disabled="requestParams.type == 'DeepSeek-R1'"
            style="width: calc(100% - 1.5rem);height: .5rem;padding: 0 0 0 .11rem;"
            v-model:value="requestParams.content" @search="search" />
        </a-input-group>
      </section>
      <section class="deepseek-btns" v-if="requestParams.type === 'DeepSeek-R1'">
        <span class="new-dialogue-btn active" @click="clickDeepSeekBtn(1)">开启新对话</span>
        <span class="deep-thinking-btn" :class="deepseekParams.model === 'deepseek-reasoner' && 'active'"
          @click="clickDeepSeekBtn(2)">深度思考（R1）</span>
        <span class="online-search-btn" :class="'active'" @click="clickDeepSeekBtn(3)">联网搜索</span>
      </section>
      <section class="hot-text" v-else>
        <span>热门搜索：</span>
        <span v-for="item in hotTextList" :key="item.score" class="hot-item" @click="clickHotWord(item.value)">{{
          item.value }}</span>
      </section>
    </section>
    <DeepSeekResult v-if="requestParams.type === 'DeepSeek-R1'" :deepseekParams="deepseekParams"
      :clearDeepSeekType="clearDeepSeekType" />
    <section v-else class="content">
      <ul class="type-list">
        <li class="report-item" v-for="item in typeList" :key="item.name" @click="changeReport(item.name)"
          :class="reportId == item.name && 'active'">{{ item.label }}</li>
      </ul>

      <ul class="item-list">
        <li class="item" v-for="item in itemListEdit" :key="item.id">
          <section class="item-sec">
            <a-checkbox v-if="deleteStatus" v-model:checked="item.checked" @change="checkChange(item.id)"></a-checkbox>
            <img :src="baseUrl + (item.reportFile && item.reportFile.overviewUrl)" alt="图片加载失败">
            <div class="right-content" v-if="!editStatus">
              <p class="title" @click="seePdf(item.reportFile.url, item)" :title="item.name"><span>{{ item.name
              }}</span>
              </p>
              <div>
                <p class="name" :title="item.owner">{{ item.owner }}</p>
                <span class="time">{{ item.reportDate }}</span>
                <span class="integral">{{ item.integral }} 积分/篇</span>
              </div>
            </div>

            <span v-if="!editStatus && reportId === '国别报告'" class="type">{{ item.country }}</span>
            <span v-if="!editStatus && reportId === '矿种报告'" class="type">{{ item.minerals }}</span>

          </section>

        </li>
      </ul>
      <section v-if="!editStatus && !deleteStatus">
        <a-pagination v-model:current="pageParams.current" :page-size-options="pageParams.pageSizeOptions"
          :total="pageParams.total" show-size-changer defaultPageSize="8" :page-size="pageParams.pageSize"
          @change="onShowSizeChange" @showSizeChange="onShowSizeChange">
        </a-pagination>
      </section>
    </section>

    <CustomModal :option="upLoadModalConf" @confirm="upLoadModalConf.callback" @close="close" class="market-modal">
      <template v-slot:main>
        <section class="detail-modal-container">
          <img class="img_ky_bg" :src="baseUrl + upLoadModalConf.imgUrl" alt="图片加载失败">
        </section>
      </template>
    </CustomModal>
  </section>
</template>

<script setup>
import { onBeforeMount, ref, reactive, watch, } from 'vue';
import { getDicInfoApi, } from '@/api/drillLibrary/utilsApi';
import { getMineralsApi, getCountryApi, } from '@/api/utils/utilsApi';
import { getHotTextApi, getPageApi, getOverviewApi, getDownloadApi, } from '@/api/Portal/marketApi';
import CustomModal from '@/components/lib/Modal/modal1.vue';
import DeepSeekResult from "./DeepSeekResult.vue";
import { downLoadUtil, } from '@/components/utils/utils';
import config from '@/config/config';
import { message } from 'ant-design-vue';

const baseUrl = ref('');
const role = ref('');
const reportId = ref('');
const editStatus = ref(false);
const deleteStatus = ref(false);
const clearDeepSeekType = ref(1)

/**
 * 下载pdf文件
 */
const downLoadFile = () => {
  getDownloadApi({ id: upLoadModalConf.reportFile.id, check: true }).then((res) => {
    downLoadUtil(res).then(() => {
      message.success('下载成功！');
    });

  });
};
const upLoadModalConf = reactive({
  loading: false,
  visible: false,
  notFootertype: 'downLoad',
  width: '10rem',
  title: '文件查看',
  callback: downLoadFile,
});

const typeList = ref([]);
const hotTextList = ref([]);
const checkList = ref([]);
const itemList = ref([]);
const itemListEdit = ref([]);
const countryList = ref([]);
const mineList = ref([]);
const reportTypeList = ref([
  { id: 1, name: '本地报告', label: '本地报告', value: '本地报告', },
  { id: 6, name: 'DeepSeek-R1', label: 'DeepSeek-R1', value: 'DeepSeek-R1', }
]);

const pageParams = ref({
  pageSizeOptions: ['8', '16', '24', '32', '40',],
  current: 1,
  pageSizeRef: 8,
  total: 0,
});

const requestParams = ref({
  content: '',
  order: '',
  page: pageParams.value.current,
  sidx: '',
  size: pageParams.value.pageSizeRef,
  type: '本地报告',
});

const deepseekParams = reactive({
  "messages": [],
  "model": "deepseek-chat",
  "frequency_penalty": 0,
  "max_tokens": 2048,
  "presence_penalty": 0,
  "response_format": {
    "type": "text"
  },
  "stop": null,
  "stream": false,
  "stream_options": null,
  "temperature": 1,
  "top_p": 1,
  "tools": null,
  "tool_choice": "none",
  "logprobs": false,
  "top_logprobs": null
});


const getTable = () => {
  const params = JSON.parse(JSON.stringify(requestParams.value))
  params.type = reportId.value

  getPageApi(params).then((res) => {
    let list = res.data.list;
    itemList.value = JSON.parse(JSON.stringify(list));
    itemListEdit.value = JSON.parse(JSON.stringify(list));
    pageParams.value.total = res.data.totalCount;
  });
};
const search = () => {
  pageParams.value.pageSizeRef = 8;
  pageParams.value.current = 1;
  requestParams.value.page = 1;
  requestParams.value.size = 8;
  reportId.value = '';
  getTable();
};
/**
 * 点击切换热词
 * @param ele 
 */
const clickHotWord = (ele) => {
  requestParams.value.content = ele;
  search();
};

/**
 * 选择deepseek查询类型
 * @param btnType  1-新对话按钮，2-深度思考按钮，3-联网按钮  
 */
const clickDeepSeekBtn = (btnType) => {
  if (btnType === 1) {
    clearDeepSeekType.value = clearDeepSeekType.value + 1
  } else if (btnType === 2) {
    deepseekParams.model = deepseekParams.model === 'deepseek-chat' ? 'deepseek-reasoner' : 'deepseek-chat'
  } else {

  }
}

const onShowSizeChange = (current, pageSize) => {
  pageParams.value.pageSizeRef = pageSize;
  pageParams.value.current = current;
  requestParams.value.page = current;
  requestParams.value.size = pageSize;
  getTable();
};

const close = () => {
  upLoadModalConf.visible = false;

};
const checkChange = (id) => {
  if (checkList.value.indexOf(id) > -1) {
    checkList.value.splice(checkList.value.indexOf(id), 1);
  } else {
    checkList.value.push(id);
  }
};

/**
 * 查看pdf文件
 * @param {文件存放地址} url
 */
const seePdf = (url, item) => {
  getOverviewApi(item.reportFile.id).then((res) => {
    // 请求大洲 清空选中的值
    if (res.code === 200) {
      upLoadModalConf.visible = true;
      upLoadModalConf.imgUrl = res.data.msg;
      upLoadModalConf.reportFile = item;
    }
  });
  // window.open( baseUrl.value + url);
};
/**
 * 切换报告种类
 * @param {选中的报告种类} id
 */
const changeReport = (id) => {
  reportId.value = reportId.value === id ? '' : id;
  pageParams.value.pageSizeRef = 8;
  pageParams.value.current = 1;
  requestParams.value.page = 1;
  requestParams.value.size = 8;
  getTable();
};
/**
 * 获取报告种类
 */

getDicInfoApi('dicType=report').then((res) => {
  let list = [];

  res.data.forEach((ele, i) => {
    list.push({ id: i, name: ele, label: ele, value: ele, });
    typeList.value.push({ id: i, name: ele, label: ele, value: ele, })
  });
  list.push({
    id: 6, name: 'DeepSeek-R1', label: 'DeepSeek-R1', value: 'DeepSeek-R1',
  })
  getTable();
});
/**
 * 获取国家列表
 */
const getCountryList = () => {
  getCountryApi({ id: '', }).then((res) => {
    // 请求大洲 清空选中的值
    if (res.code === 200) {
      // countryList.value = res.data.data;
      countryList.value = res.data.map((item) => ({ ...item, value: item.countryName, label: item.countryName, }));
    }
  });
};
/**
 * 获取框中列表
 */
const getMineList = () => {
  getMineralsApi().then((res) => {
    let list = res.data;

    mineList.value = res.data.map((item) => ({ ...item, value: item.name, label: item.name, }));
  });
};
/**
 * 获取热词
 */
const getHotText = () => {
  getHotTextApi().then((res) => {
    hotTextList.value = res.data;
  });
};

onBeforeMount(() => {
  role.value = config.getPermissionId();
  if (role.value === 1) {
    getMineList();
    getCountryList();
    getHotText();
  }
  if (process.env.NODE_ENV === 'development') {
    baseUrl.value = 'http://10.106.7.138:8080/';
  } else {
    baseUrl.value = window.location.origin;
  }
});



</script>

<style lang='scss'>
// @import url(../Index/axure_rp_page.css);
// @import url(./styles.css);

.mining-report {
  width: 100%;
  height: 100vh;
  background: url(./../../../static/images/portal/index/content-bg.png) no-repeat;
  position: relative;
  z-index: 0;

  .video {
    width: 100%;
    height: 4rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -99;
  }

  .top-search {
    height: 4rem;

    // background: url(./../../../static/images/portal/index/bjzz.png) no-repeat;
    .small-title {
      padding: 1.6rem 0 .4rem 0;
      text-align: center;
      z-index: 10;

      img {
        width: 5rem;
        height: .64rem;
      }
    }

    .search-content {
      width: 9rem;
      height: .5rem;
      margin: 0 auto;

      .ant-select-selector {
        height: 100%;
      }

      .search-group {
        .ant-select {
          .ant-select-selection-item {
            padding-right: 0;
            line-height: .5rem;
            font-size: .16rem;
          }
        }

        .ant-input-suffix {
          width: .8rem;
          background: #E9BA40;

          .anticon-search {
            font-size: .3rem;
            color: #fff;
            padding-left: .2rem;
          }
        }
      }
    }

    .hot-text {
      padding-left: 5.1rem;
      color: #fff;
      margin-top: .3rem;

      span {
        margin-right: .2rem;
      }

      .hot-item {
        cursor: pointer;
      }
    }
  }

  .deepseek-btns {
    width: 9rem;
    padding: .2rem 0 0 1.7rem;
    margin: 0 auto;
    display: flex;
    gap: .16rem;

    span {
      display: flex;
      padding: 0 .12rem 0 .32rem;
      line-height: .28rem;
      height: .32rem;
      border-radius: .16rem;
      font-size: .16rem;
      color: #404040;
      border: 1px solid rgba(64, 64, 64, 0.2);
      cursor: pointer;
      background: url(~@/static/images/DeepSeek/dialogue.png) no-repeat left center;
      background-size: .16rem .16rem;
      background-position: .12rem center;
      background-color: #FFFFFF;



      &.active {
        color: #D89F07;

        &.new-dialogue-btn {
          background-image: url(~@/static/images/DeepSeek/dialogue.png);
        }

        &.deep-thinking-btn {
          background-image: url(~@/static/images/DeepSeek/think-active.png);
        }

        &.online-search-btn {
          background-image: url(~@/static/images/DeepSeek/networking-active.png);
        }
      }
    }

    .new-dialogue-btn {}

    .deep-thinking-btn {
      background-image: url(~@/static/images/DeepSeek/think.png);
    }

    .online-search-btn {
      background-image: url(~@/static/images/DeepSeek/networking.png);
    }
  }

  .content {
    padding: .4rem 1.22rem 0;
    height: calc(100% - 4rem);
    background-size: 100% 100%;
    position: relative;
    z-index: 100;

    .type-list {
      display: flex;
      align-items: center;
      justify-content: center;

      .report-item {
        color: #F5F5F5;
        width: 1.4rem;
        height: .6rem;
        text-align: center;
        line-height: .55rem;
        font-size: .18rem;
        margin: 0 .2rem;
        cursor: pointer;
        background: url(./../../../static/images/portal/index/report-item.png) no-repeat;
      }

      .active {
        background: url(./../../../static/images/portal/index/report-item-active.png) no-repeat;
      }
    }

    .btn-list {
      position: absolute;
      right: 1.3rem;
      top: .6rem;
      display: flex;
      align-items: center;
      font-size: .18rem;
      color: #fff;

      li {
        margin: 0 .1rem;
        padding: .05 .1rem;
        width: .6rem;
        height: .25rem;
        cursor: pointer;
        text-align: center;
        line-height: .2rem;
        background: url(./../../../static/images/dataManagement/curd_btn.png) no-repeat;
      }
    }

    .btn-list-ok {
      position: absolute;
      right: 2.8rem;
      top: .6rem;
      display: flex;
      align-items: center;
      font-size: .18rem;
      color: #fff;

      li {
        margin: 0 .1rem;
        padding: .05 .1rem;
        cursor: pointer;
        background-color: #8C641E;
        padding: .05rem 0.08rem;
        border-radius: 0.02rem;
      }
    }

    .item-list {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      overflow: auto;
      height: calc(100% - 0.96rem);

      .item {
        width: 25%;
        display: flex;
        justify-content: center;
        margin-top: 0.25rem;

        .item-sec {
          width: 3.9rem;
          height: 1.7rem;
          background: url(./../../../static/images/portal/index/item-list.png) no-repeat;
          background-size: 3.9rem 1.5rem;
          background-position: 0 0.2rem;
          position: relative;

          .ant-checkbox-wrapper {
            position: absolute;
            right: .3rem;
            top: .1rem;
          }

          img {
            width: 1.27rem;
            height: 1.49rem;
            position: absolute;
            bottom: 0.16rem;
            left: 0.06rem;
          }

          .right-content {
            color: #fff;

            .title {
              position: absolute;
              top: 0.6rem;
              left: 1.5rem;
              cursor: pointer;

              // background: #8C641E;
              // padding: .05rem;
              span {
                max-width: 2rem;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                /* 这里是超出几行省略 */
                overflow: hidden;
                font-size: 0.16rem;
                line-height: .2rem;
              }

              &:hover {
                color: #4395ff;
              }
            }

            .name {
              position: absolute;
              top: 1rem;
              left: 1.5rem;
              font-size: .14rem;
              max-width: 2rem;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              /* 这里是超出几行省略 */
              overflow: hidden;
              opacity: .6;
            }

            .time {
              position: absolute;
              top: 1.3rem;
              left: 1.5rem;
              font-size: .14rem;
              opacity: .6;
            }

            .integral {
              position: absolute;
              top: 1.3rem;
              left: 2.7rem;
              font-size: .14rem;
              opacity: .6;
              width: .8rem;
            }
          }

          .type {
            position: absolute;
            top: 0.32rem;
            right: 0.35rem;
            color: #fff;
            font-size: .14rem;
            font-style: oblique;
          }

          .ant-select-selector {
            background: transparent;
            width: 2rem;
            font-size: .14rem;
            height: .3rem;
          }

          .ant-input {
            background: transparent;
            color: #fff;
            width: 2rem;
            font-size: .14rem;
            height: .30rem;
          }

          input.name {
            width: 2rem;
          }

          .ant-calendar-picker {
            .ant-calendar-picker-input {
              background: transparent;
              height: .30rem;
              color: #fff;
              width: 1rem;
            }
          }
        }
      }
    }

    .ant-pagination {
      text-align: right;

      .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
        padding-right: .15rem;
      }
    }
  }
}

.market-modal {
  .default1-modal-main {
    .form-item {
      display: flex;
      align-items: center;
      margin: .1rem 0;

      label {
        width: 1.2rem;
        font-size: .16rem;
      }

      .ant-input,
      .ant-select {
        width: calc(100% - 1.2rem);
      }

      .ant-calendar-picker {
        width: 2rem;

        .ant-input {
          width: 100%;
        }
      }

      .ant-select {
        color: #fff;

        .ant-select-selector {
          background: transparent;
          height: .43rem;
          border-color: #695933;

          .ant-select-selection-item {
            font-size: .16rem;
            line-height: .43rem;
          }
        }

        .ant-select-arrow {
          color: #fff;
        }
      }

      .file-upload-container {
        .ant-btn {
          background: #8C641E;
          color: #fff;
          border-color: #695933;
          margin-right: .1rem;
        }
      }
    }
  }
}
</style>